import { createContext, useContext } from 'react';

interface SharedPageContextType {
  isForPdf?: boolean;
}

export const SharedPageContext = createContext<SharedPageContextType>({});

export const useSharedPageContext = () => {
  return useContext(SharedPageContext);
};
